import { render, staticRenderFns } from "./form-knowledge-bank.vue?vue&type=template&id=95f85b54&scoped=true&"
import script from "./form-knowledge-bank.vue?vue&type=script&lang=js&"
export * from "./form-knowledge-bank.vue?vue&type=script&lang=js&"
import style0 from "./form-knowledge-bank.vue?vue&type=style&index=0&id=95f85b54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f85b54",
  null
  
)

export default component.exports